/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectPenaltyDetailsTemplateCommandResult } from '../../models/create-project-penalty-details-template-command-result';

export interface ApiProjectPenaltiesDetailsTemplateCreateProjectPenaltyDetailsTemplatePost$Plain$Params {
      body?: {
'Name'?: string;
'Value'?: number;
'Code'?: string;
'PenaltyId'?: string;
}
}

export function apiProjectPenaltiesDetailsTemplateCreateProjectPenaltyDetailsTemplatePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesDetailsTemplateCreateProjectPenaltyDetailsTemplatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyDetailsTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesDetailsTemplateCreateProjectPenaltyDetailsTemplatePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectPenaltyDetailsTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesDetailsTemplateCreateProjectPenaltyDetailsTemplatePost$Plain.PATH = '/api/ProjectPenaltiesDetailsTemplate/CreateProjectPenaltyDetailsTemplate';
